import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  useTheme,
  Fade
} from "@mui/material";
import {
  Receipt as ReceiptIcon
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useAuthToken } from "../../TokenContext";
import axios from "axios";
import moment from "moment";
import { getBucketName, getRegion, getAccessKeyId, getSecretAccessKey } from '../../credentialsService';

const config = {
  bucketName: getBucketName(),
  region: getRegion(),
  accessKeyId: getAccessKeyId(),
  secretAccessKey: getSecretAccessKey()
};

const S3Config = {
  region: getRegion(),
  accessKeyId: getAccessKeyId(),
  secretAccessKey: getSecretAccessKey()
};

const PartnerInvoices = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const intl = useIntl();
  const token = useAuthToken();
  const { isLoggedIn, user } = useSelector(state => state.auth);
  
  const [getpoddetails, setGetpoddetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [id, setId] = useState('');

  useEffect(() => {
   
      const body = {

        customerId: user?.data[0].customerId || null,
      }
    const headers = {
      'Authorization': token,
      'Content-Type': 'application/json',
    };
    axios
      .post(process.env.REACT_APP_CLIENT_LISTOFINVOICES, body, { headers: headers })
      .then((res) => {
        const responseData = JSON.parse(res.data.body);
        setGetpoddetails(responseData.body);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error:", err);
        setErrorMessage("Failed to fetch data. Please try again later.");
        setIsLoading(false);
      });
  }, [token]);

  return (
    <Container maxWidth="lg" sx={{ mt: 8, mb: 4 }}>
      <Fade in timeout={600}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 600,
              mb: 4,
              color: isDarkMode ? 'grey.100' : 'text.primary'
            }}
          >
            {intl.formatMessage({ id: "yourInvoices" })}
          </Typography>

          <Paper
            elevation={3}
            sx={{
              width: '100%',
              maxWidth: 900,
              borderRadius: 3,
              overflow: 'hidden',
              bgcolor: isDarkMode ? 'grey.900' : '#f2f4f5',
              p: 2
            }}
          >
            {isLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress />
                <Typography sx={{ ml: 2, color: isDarkMode ? 'grey.300' : 'text.secondary' }}>
                  {intl.formatMessage({ id: "loading" })}...
                </Typography>
              </Box>
            ) : errorMessage ? (
              <Typography sx={{ p: 4, textAlign: 'center', color: 'error.main' }}>
                {errorMessage}
              </Typography>
            ) : !Array.isArray(getpoddetails) || getpoddetails.length === 0 ? (
              <Typography sx={{ p: 4, textAlign: 'center', color: isDarkMode ? 'grey.400' : 'text.secondary' }}>
                {intl.formatMessage({ id: "noInvoices" })}
              </Typography>
            ) : (
              <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                <Table 
                  sx={{ 
                    maxWidth: 900, 
                    fontFamily: 'Poppins,Medium',
                    bgcolor: isDarkMode ? 'grey.800' : '#fff'
                  }} 
                  aria-label="simple table"
                >
                  <TableHead 
                    sx={{ 
                      backgroundColor: isDarkMode ? '#00a0c4' : '#00B4D8',
                      '& td, & th': { 
                        fontFamily: 'Poppins,Medium', 
                        fontSize: '15px', 
                        color: 'white', 
                        fontWeight: '600' 
                      } 
                    }}
                  >
                    <TableRow>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        {intl.formatMessage({ id: "amountPaid" })}
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        {intl.formatMessage({ id: "date" })}
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        {intl.formatMessage({ id: "status" })}
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        {intl.formatMessage({ id: "amountDue" })}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getpoddetails.map((x, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          '&:last-child td, &:last-child th': { 
                            border: 0, 
                            fontFamily: 'Poppins,Medium', 
                            fontSize: '15px' 
                          },
                          '&:nth-of-type(even)': {
                            backgroundColor: isDarkMode ? 'rgba(144, 224, 239, 0.1)' : '#90E0EF'
                          },
                          '&:nth-of-type(odd)': {
                            backgroundColor: isDarkMode ? 'rgba(202, 240, 248, 0.1)' : '#caf0f8'
                          },
                          '& td, & th': {
                            fontFamily: 'Poppins,Medium',
                            fontSize: '15px',
                            color: isDarkMode ? 'grey.100' : 'black',
                          },
                        }}
                      >
                        <TableCell align="right">{x.amount_paid}</TableCell>
                        <TableCell align="right">{x.created}</TableCell>
                        <TableCell align="right">{x.status}</TableCell>
                        <TableCell align="right">{x.amount_due}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Box>
      </Fade>
    </Container>
  );
};

export default PartnerInvoices;